export default {
    tab: {
        0: 'Mega-Trends',
        1: 'Macro-Trends'
    }
}
